// Snow Effect Component - Performance-optimiert mit erweiterten Parametern
import React, { useRef, useEffect, memo } from 'react';
import { DevicePerformance } from '../../utils/performance.js';
import { SNOW_EVENTS } from '../../config/events.js';

export const SnowEffect = memo(function SnowEffect({ intensity = 50, activeEvent, effectConfig = {} }) {
  const containerRef = useRef(null);
  
  useEffect(() => {
    if (!containerRef.current || !SNOW_EVENTS.includes(activeEvent)) return;
    
    const container = containerRef.current;
    container.innerHTML = '';
    
    if (DevicePerformance.prefersReducedMotion) return;
    
    const count = DevicePerformance.getIntensity(Math.floor(intensity * 0.5));
    if (count === 0) return;
    
    // Effekt-Konfiguration aus Settings
    const speed = effectConfig.speed || 50;
    const direction = effectConfig.direction || 'down';
    const randomness = effectConfig.randomness || 30;
    const customIcon = effectConfig.customIconUrl;
    const manualIcon = effectConfig.manualIcon;
    
    // Icon-Mapping
    const iconMap = {
      snowflake: '❄️',
      bubble: '🫧',
      heart: '❤️',
      star: '⭐',
      sparkle: '✨',
      confetti: '🎉',
      leaf: '🍂',
      flower: '🌸',
      sun: '☀️',
      moon: '🌙',
    };
    
    // Batch-DOM-Operationen mit DocumentFragment
    const fragment = document.createDocumentFragment();
    
    for (let i = 0; i < count; i++) {
      const flake = document.createElement('div');
      flake.className = 'snowflake';
      
      // Custom Icon oder Standard
      if (manualIcon === 'custom' && customIcon) {
        const img = document.createElement('img');
        img.src = customIcon;
        img.alt = '';
        img.style.cssText = 'width: 100%; height: 100%; object-fit: contain;';
        flake.appendChild(img);
      } else if (manualIcon && iconMap[manualIcon]) {
        flake.textContent = iconMap[manualIcon];
      } else {
        flake.textContent = '❄';
      }
      
      const size = 8 + Math.random() * 12;
      const baseSpeed = 8 + Math.random() * 6;
      const adjustedSpeed = baseSpeed * (100 / speed);
      const randomOffset = (Math.random() - 0.5) * (randomness / 10);
      
      // Richtung anpassen
      let animationName = 'snowfall';
      if (direction === 'up') animationName = 'snowfall-up';
      if (direction === 'left') animationName = 'snowfall-left';
      if (direction === 'right') animationName = 'snowfall-right';
      
      flake.style.cssText = `
        left: ${Math.random() * 100}%;
        font-size: ${size}px;
        opacity: ${0.4 + Math.random() * 0.5};
        animation: ${animationName} ${adjustedSpeed}s linear infinite;
        animation-delay: ${Math.random() * 4}s;
        transform: translateX(${randomOffset}px);
      `;
      fragment.appendChild(flake);
    }
    
    container.appendChild(fragment);
    
    return () => { container.innerHTML = ''; };
  }, [intensity, activeEvent, effectConfig]);
  
  return <div ref={containerRef} className="snow-container" aria-hidden="true" />;
});
